import { render, staticRenderFns } from "./StepTab.vue?vue&type=template&id=590295a0&"
import script from "./StepTab.vue?vue&type=script&lang=js&"
export * from "./StepTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports